import { api } from '../../../utils/client';
import type { AdminTier, TierFormValue, TiersMeta } from './types';
import { formToPayload } from './types';

export async function fetchTiersMeta() {
  return api<TiersMeta>('/api/admin/tiers/meta/');
}

export async function fetchTiers(params?: { q?: string; is_active?: '' | 'true' | 'false' }) {
  const search = new URLSearchParams();
  if (params?.q) search.set('q', params.q);
  if (params?.is_active) search.set('is_active', params.is_active);
  const qs = search.toString();
  return api<{ results: AdminTier[] }>(`/api/admin/tiers/${qs ? `?${qs}` : ''}`);
}

export async function createTier(value: TierFormValue) {
  return api<AdminTier>('/api/admin/tiers/', {
    method: 'POST',
    body: JSON.stringify(formToPayload(value, 'create')),
  });
}

export async function updateTier(id: number, value: TierFormValue) {
  return api<AdminTier>(`/api/admin/tiers/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(formToPayload(value, 'edit')),
  });
}
